import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { connect } from 'react-redux';
import ContactSalesForm from './ContactSalesForm';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  '@keyframes loadEffect': {
    '0%': {
      transform: 'scale(0.95)',
      opacity: 0,
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
    },
  },
  pageHeader: {
    alignSelf: 'center',
    paddingTop: theme.spacing(3),
  },
  upgradeContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    animation: `$loadEffect 500ms`,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
}));

const ContactSales = () => {
  const classes = useStyles();
  
  return (
    <Box className={classNames(classes.upgradeContent)}>
      <h1 className={classes.pageHeader}>
        <FormattedMessage id="contact.sales.header" defaultMessage="Contact sales" />
      </h1>
    
      <ContactSalesForm />
    </Box>
  );
};

ContactSales.propTypes = {
  user: PropTypes.object,
};

export default compose(
  connect(store => ({
    user: store.user.profile,
  })),
)(ContactSales);
